import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../components/Designation/Designation.css";

const Designation = ({tokenStorage,openProfile,setOpenProfile, selectedDesignationId, successMessage, setSuccessMessage }) => {
  const [departmentResponse, setDepartmentResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);
    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDesignation?department=0&designation=` +
          selectedDesignationId,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({
    dept_id: "",
    desg_id: selectedDesignationId,
    designation: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setFirstItem({
      desg_id: selectedDesignationId,
    });
    
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddDesignation`,
        firstItem, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );


      //to show success message
      setSuccessMessage("Data successfully saved");

      // Optionally, reset the form
      setFirstItem({
        designation: "",
      });
      tokenStorage();
      setOpenProfile (!openProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  // -----------------------------department-----------------------
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDepartment?department=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setDepartmentResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    <div className="container-fluid">
      <br />

      <div className="designationDetail">
      {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )} 
        <form className="designation-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Department Name*</td>
              <td>Designation Name*</td>
            </tr>

            <tr>
              <td>
              <select
                    className="dropdown-employee"
                    name="dept_id"
                    value={firstItem.dept_id}  
                    onChange={handleChange}                 
                    style={{ height: "29px", width: "13rem" }}
                  >
                    <option value="">Select an option</option>
                    {departmentResponse.map((item) => (
                      <option value={item.dept_id}>{item.department}</option>
                    ))}
                  </select>
              </td>
              <td>
              <input
                  type="text"
                  name="designation"
                  value={firstItem.designation}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addDesignation-button">
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default Designation;
